export const getStatusCodesTranslations = t => {

  const statusCodesTranslations = t => ({
    401: t('errors.statusCodes.401'),
    403: t('errors.statusCodes.403'),
    ECONNABORTED: t('errors.statusCodes.ECONNABORTED'),
    CUSTOM_STATUS_CODE_FILE_SUBMIT:  t('errors.statusCodes.CUSTOM_STATUS_CODE_FILE_SUBMIT'),
  });

  return statusCodesTranslations(t !== undefined ? t : str => str);
};



// WEBPACK FOOTER //
// ./src/constants/getStatusCodesTranslations.js